import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { MentionNodeAttrs } from '@tiptap/extension-mention';
import { getListActivities } from 'Store/Activities/Activities.selector';
import { getTheme } from 'Store/MultiDomain/MultiDomain.selector';
import MentionActivityComponentRender from './MentionActivityComponentRender';

const MentionActivityDynamicDisplay: FC<NodeViewProps> = ({ node }) => {
  const { id } = node.attrs as MentionNodeAttrs;
  const theme = useSelector(getTheme);
  const listActivities = useSelector(getListActivities);

  const activity = useMemo(() => {
    if (!listActivities?.activities || !id) return null;
    return listActivities?.activities[id];
  }, [listActivities, id]);

  if (!activity) {
    return null;
  }

  return (
    <NodeViewWrapper as="span" className="mention-activity-wrapper">
      <MentionActivityComponentRender activity={activity} theme={theme} />
    </NodeViewWrapper>
  );
};

export default MentionActivityDynamicDisplay;
